import { generatedIconMap } from "./generated-icon-map";

export type GeneratedIconName = keyof typeof generatedIconMap;

export const iconNames = Object.keys(generatedIconMap) as GeneratedIconName[];

export type IconSize = 16 | 18 | 20 | 24 | 32 | 48;

interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height"> {
  name: GeneratedIconName;
  size?: IconSize;
}

export function Icon({ name, size = 20, ...props }: IconProps) {
  const Icon = generatedIconMap[name];
  return <Icon {...props} width={size} height={size} />;
}

export function isGeneratedIconName(name: string | null | undefined): name is GeneratedIconName {
  return typeof name === "string" && Object.prototype.hasOwnProperty.call(generatedIconMap, name);
}

// TODO: in the future if we need we can add similar support for custom icons with a `<CustomIcon />` component and a similar manually managed icon map
